import _ from "lodash";
import Baobab from "baobab";

import webPlayerState from "../state/webPlayerState";

// A preview is a new in-memory exercise, never a resume of an instance found
// in an imported definition. Keep authored defaults, content and selection.
export function buildAuthoringPreviewActivity(checklist, { fallbackToTop = false } = {}) {
	if (!_.isPlainObject(checklist)) {
		return checklist;
	}
	const activity = _.cloneDeep(checklist);
	[
		"instanceId", "activityInstanceId", "assignmentId", "workItemId", "activityWorkItemId",
		"started", "submitted", "completionState", "checklistCompletionState", "progressCount", "progressTotal",
		"history", "checklistHistory", "logbook", "sync", "lastUpdatedDate",
		"activityOps", "projectOps", "projectContractAnchor", "pricingContractProto",
		"launchContext", "launchProvenance", "freshInstanceAuthorization"
	].forEach(key => delete activity[key]);
	if (fallbackToTop) {
		delete activity.selected;
		delete activity.selectedListIndex;
	}
	return activity;
}

export function createAuthoringPreviewSessionId() {
	return _.uniqueId(`authoring-preview-${Date.now()}-`);
}

export function buildAuthoringPreviewConfig(baseConfig = {}, { activityId = "preview", sessionId } = {}) {
	const config = _.cloneDeep(baseConfig);
	return {
		...config,
		authoringPreview: true,
		debugVarsInspector: true,
		persistence: {
			...(config.persistence || {}),
			authoringPreview: true,
			useInjectedActivities: true,
			previewUploads: {
				enabled: true,
				rootFolder: "previewAssets",
				activityId,
				sessionId,
				skipBackgroundProcessing: true
			}
		}
	};
}

export function buildAuthoringPreviewLaunchContext(previewChecklist = {}) {
	return {
		activityVars: _.isPlainObject(previewChecklist.activityVars) ? _.cloneDeep(previewChecklist.activityVars) : {},
		activityVarsProfileKey: previewChecklist.activityVarsProfileKey || ""
	};
}

export function buildPreviewSelectedOrgState(selectedOrg) {
	if (!_.isPlainObject(selectedOrg)) {
		return selectedOrg;
	}

	return {
		id: selectedOrg.id,
		member: _.cloneDeep(selectedOrg.member) || null
	};
}

export function buildPreviewWebPlayerState({
	user,
	selectedOrg,
	config = {}
} = {}) {
	const newWebPlayerState = new Baobab(_.cloneDeep(webPlayerState.get()));

	newWebPlayerState.set(["user"], _.cloneDeep(user) || {});
	if (selectedOrg) {
		newWebPlayerState.set(["selectedOrg"], buildPreviewSelectedOrgState(selectedOrg));
	}
	newWebPlayerState.set(["_config"], { ..._.cloneDeep(config), authoringPreview: true });
	newWebPlayerState.set(["storeCloudHistory"], false);
	newWebPlayerState.set(["appPreferences", "checkbarLocation"], "hidden");

	const nextState = newWebPlayerState.get();
	delete nextState.timerTemplates;
	return nextState;
}
